import React from 'react';
import EyeOpenStrikethroughIcon from '@atlaskit/icon/core/eye-open-strikethrough';
export var HiddenIcon = function HiddenIcon(props) {
  return /*#__PURE__*/React.createElement(EyeOpenStrikethroughIcon, props);
};